<template>
  <div id="cidadaos_visitados" class="row">
    <div class="col-md-12">
      <select-equipe-profissional
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :callbackOnChangeProfissional="onChangeProfissional"
        :activeOptionTodos="false"
        :flexSize="1"
      >
      </select-equipe-profissional>
    </div>
    <div class="col-md-12">
      <b-tabs fill class="esus-feedback-tabs" v-model="tabsActive">
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div class="row">
            <div class="full-table">
              <div class="col-md-12">
                <div class="info-table">
                  <div class="info-table-item">
                    <Subtitle
                      @exibirVermelhos="handleExibirVermelhos"
                      @exibirVerdes="handleExibirVerdes"
                      :setColor="setColor"
                      @resetColor="resetColor"
                      :setRed="exibirCadastrosVermelhos"
                      :setGreen="exibirCadastrosVerdes"
                    ></Subtitle>
                  </div>
                  <div class="select-visita info-table-item">
                    <vue-select
                      :options="visita_opcoes"
                      label="visita"
                      placeholder="Status visita"
                      v-model="visita"
                      @input="
                        visita !== null
                          ? filtros(
                              exibirCadastrosVermelhos,
                              exibirCadastrosVerdes
                            )
                          : filtros(
                              exibirCadastrosVermelhos,
                              exibirCadastrosVerdes
                            )
                      "
                      :clearable="true"
                    >
                      <template slot="option" slot-scope="option">
                        {{ option.visita }}
                      </template>
                      <div slot="no-options">Não há opções correspondentes</div>
                    </vue-select>
                  </div>
                  <div class="info-table-item">
                    <download-files
                      :callback-pdf="generatePdf"
                      :data="displayedCadastros"
                      :fields="dataFields"
                      name="cidadaos-visitados"
                    >
                    </download-files>
                  </div>
                </div>
                <tabela-cadastros-vuetfy
                  ref="table"
                  :cadastros="displayedCadastros"
                  :data_secretaria_de_saude="data_secretaria_de_saude"
                  :loading="loading"
                  texto_esus_pec="Visitas registradas até"
                  :data_esus_pec="data_secretaria_de_saude"
                  @filterSearch="filterSearch($event)"
                ></tabela-cadastros-vuetfy>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Resultado">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Resultado
          </template>
          <div class="row">
            <div class="col-md-12">
              <div class="box">
                <div class="box-header">
                  <h4 class="box-title">
                    <i class="icofont-listine-dots"></i> Cidadãos visitados
                  </h4>
                </div>
                <div class="box-body">
                  <table
                    class="table table-responsive table-bordered text-center table2"
                    id="table"
                  >
                    <thead>
                      <tr>
                        <th>Por</th>
                        <th>Total</th>
                        <th>
                          A visitar / Dia
                          <span
                            v-b-tooltip.hover
                            title="Estimativa para visitar todos os cidadãos em 30 dias"
                            class="icon-tooltip"
                          >
                            <i class="icofont-info-circle"></i>
                          </span>
                        </th>
                        <th>
                          Menos de 30 dias
                          <span
                            v-b-tooltip.hover
                            title="Cidadãos visitados no últimos 30 dias"
                            class="icon-tooltip"
                          >
                            <i class="icofont-info-circle"></i>
                          </span>
                        </th>
                        <th>
                          Mais de 30 dias
                          <span
                            v-b-tooltip.hover
                            title="Cidadãos visitados há mais de 30 dias"
                            class="icon-tooltip"
                          >
                            <i class="icofont-info-circle"></i>
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Município</td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              secretaria_municipal_de_saude_total_no_municipio
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              Math.round(
                                secretaria_municipal_de_saude_total_no_municipio /
                                  21
                              )
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center green font-weight-bold">
                          <loader
                            :value="`
                                ${(
                                  (secretaria_municipal_de_saude_total_no_municipio /
                                    100) *
                                  secretaria_municipal_de_saude_no_municipio_atualizados
                                ).toFixed(0)}

                                (${secretaria_municipal_de_saude_no_municipio_atualizados}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                        <td class="text-center red font-weight-bold">
                          <loader
                            :value="`
                                ${(
                                  (secretaria_municipal_de_saude_total_no_municipio /
                                    100) *
                                  secretaria_municipal_de_saude_no_municipio_desatualizados
                                ).toFixed(0)}

                                (${secretaria_municipal_de_saude_no_municipio_desatualizados}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                      </tr>
                      <tr>
                        <td>Equipe</td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              secretaria_municipal_de_saude_total_na_equipe
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              Math.round(
                                secretaria_municipal_de_saude_total_na_equipe /
                                  21
                              )
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center green font-weight-bold">
                          <loader
                            :value="`
                                ${(
                                  (secretaria_municipal_de_saude_total_na_equipe /
                                    100) *
                                  secretaria_municipal_de_saude_na_equipe_atualizados
                                ).toFixed(0)}

                                (${secretaria_municipal_de_saude_na_equipe_atualizados}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                        <td class="text-center red font-weight-bold">
                          <loader
                            :value="`
                                  ${(
                                    (secretaria_municipal_de_saude_total_na_equipe /
                                      100) *
                                    secretaria_municipal_de_saude_na_equipe_desatualizados
                                  ).toFixed(0)}
                                  (${secretaria_municipal_de_saude_na_equipe_desatualizados}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                      </tr>
                      <tr>
                        <td>ACS</td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="secretaria_municipal_de_saude_total_no_acs"
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              Math.round(
                                secretaria_municipal_de_saude_total_no_acs / 21
                              )
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center green font-weight-bold">
                          <loader
                            :value="`
                                  ${(
                                    (secretaria_municipal_de_saude_total_no_acs /
                                      100) *
                                    secretaria_municipal_de_saude_no_acs_atualizados
                                  ).toFixed(0)}
                                  (${secretaria_municipal_de_saude_no_acs_atualizados}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                        <td class="text-center red font-weight-bold">
                          <loader
                            :value="`
                                  ${(
                                    (secretaria_municipal_de_saude_total_no_acs /
                                      100) *
                                    secretaria_municipal_de_saude_no_acs_desatualizados
                                  ).toFixed(0)}
                                  (${secretaria_municipal_de_saude_no_acs_desatualizados}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <FonteEsusPecGlobal
                    texto="Visitas registradas até"
                    :data="data_secretaria_de_saude"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Mapa" @click="loadMap()">
          <template v-slot:title>
            <i class="icofont-ui-map"></i> Mapa
          </template>
          <div class="row">
            <div class="col-12">
              <div class="info-table">
                <div class="info-table-item">
                  <Subtitle
                    @exibirVermelhos="handleExibirVermelhos"
                    @exibirVerdes="handleExibirVerdes"
                    :setColor="setColor"
                    @resetColor="resetColor"
                    :setRed="exibirCadastrosVermelhos"
                    :setGreen="exibirCadastrosVerdes"
                  ></Subtitle>
                </div>
                <div class="select-visita info-table-item">
                  <vue-select
                    :options="visita_opcoes"
                    label="visita"
                    placeholder="Status visita"
                    v-model="visita"
                    @input="
                      visita !== null
                        ? filtros(
                            exibirCadastrosVermelhos,
                            exibirCadastrosVerdes
                          )
                        : filtros(
                            exibirCadastrosVermelhos,
                            exibirCadastrosVerdes
                          )
                    "
                    :clearable="true"
                  >
                    <template slot="option" slot-scope="option">
                      {{ option.visita }}
                    </template>
                    <div slot="no-options">Não há opções correspondentes</div>
                  </vue-select>
                </div>
              </div>
            </div>
            <div class="col-12 mapa">
              <l-map
                :zoom.sync="zoom"
                :center="center"
                style="height: 500px; width: 100%"
                ref="map"
                :options="{ zoomControl: false }"
              >
                <l-tile-layer :url="url" :attribution="attribution" />
                <l-control-zoom position="bottomright"></l-control-zoom>
                <!--  <l-marker
                      :lat-lng="[`${markerLatLng[0]}`, `${markerLatLng[1]}`]"
                      :icon="iconColor('2022-04-12', '1')"
                    >
                    </l-marker> -->

                <l-marker
                  v-for="(pessoa, index) in cadastrosMapa"
                  :key="'marker-' + index"
                  :lat-lng="[
                    `${pessoa.lat ? pessoa.lat : '0'}`,
                    `${pessoa.lng ? pessoa.lng : '0'}`,
                  ]"
                  :icon="
                    iconColor(
                      pessoa.dt_ultima_visita,
                      pessoa.desfecho,
                      pessoa.lat,
                      pessoa.lng
                    )
                  "
                >
                  <l-tooltip>
                    <div class="tooltip-latlgn">
                      {{ pessoa.no_cidadao }}
                    </div>
                  </l-tooltip>
                </l-marker>
              </l-map>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import TabelaCadastrosVuetfy from './TabelaCadastrosVuetfy.vue'
import * as Functions from './functions.js'
import mapa from '@/pages/PrevineBrasil/arquivos/mapa_ranking_regional'
import { mask } from 'vue-the-mask'
import Subtitle from './Subtitle'
import { coordinates } from '@/pages/PrevineBrasil/coordinates'
import {
  LMap,
  LCircle,
  LTileLayer,
  LCircleMarker,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
} from 'vue2-leaflet'
import { latLng, icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import SelectEquipeProfissional from '@/components/utils/SelectEquipeProfissional.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import utils from '@/mixins/utils.js'

export default {
  name: 'CidadaosVisitadosPorEquipeAcs',
  directives: { mask },
  components: {
    LMap,
    LCircle,
    LTileLayer,
    LMarker,
    LIcon,
    LCircleMarker,
    LTooltip,
    LControlZoom,
    PulseLoader,
    Loader,
    Subtitle,
    TabelaCadastrosVuetfy,
    SelectEquipeProfissional,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      /*     markerLatLng: [-16.57898541449999, -48.498747024193634], */
      iconSize: 64,
      zoom: 10,
      center: latLng(-15.2, -51.31),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      iconVerde: icon({
        iconUrl: require('@/assets/images/marcadores-mapa/pessoa-verde.svg'),
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),
      iconVermelho: icon({
        iconUrl: require('@/assets/images/marcadores-mapa/pessoa-vermelho.svg'),
        iconSize: [32, 37],
        iconAnchor: [16, 37],
      }),
      tabsActive: 0,
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipe: '',
      profissionais: [],
      profissional: '',
      visibleDataAcs: false,
      cadastros: [],
      page: 1,
      perPage: 10,
      pages: [],
      data_ministerio_da_saude: null,
      populacaoIbge: 0,
      totalCadastrosMunicipio: 0,
      totalCadastrosEquipe: '',
      parametro: '',
      diferencaDeCadastros: '',
      diferenca_no_municipio: '',
      resultado_no_municipio: '',
      diferenca_na_equipe: '',
      resultado_na_equipe: '',
      total_de_registros_da_tabela: 0,
      secretaria_municipal_de_saude_total_no_municipio: 0,
      secretaria_municipal_de_saude_no_municipio_atualizados: 0,
      secretaria_municipal_de_saude_no_municipio_desatualizados: 0,
      secretaria_municipal_de_saude_total_na_equipe: 0,
      secretaria_municipal_de_saude_na_equipe_atualizados: 0,
      secretaria_municipal_de_saude_na_equipe_desatualizados: 0,
      secretaria_municipal_de_saude_total_no_acs: 0,
      secretaria_municipal_de_saude_no_acs_atualizados: 0,
      secretaria_municipal_de_saude_no_acs_desatualizados: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      visibleTable: false,
      nomeEquipe: '',
      nomeProfissional: '',
      dadosDoResultado: [],
      cadastrosOriginais: [],
      cadastrosMapa: [],
      cidadaos_visitados: [],
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      setColor: null,
      visita_opcoes: [
        {
          visita: 'Todos',
        },
        {
          visita: 'Realizada',
        },
        {
          visita: 'Ausente',
        },
      ],
      visita: '',
      semZoom: false,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15]
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15]
    },
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
    data_secretaria_de_saude() {
      let date = ''
      if (this.$store.getters['getUltimaAtualizacao'] !== null) {
        date = this.$store.getters['getUltimaAtualizacao']
          .split('/')
          .reverse()
          .join('-')
      }
      return date
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    async filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      if (vermelho === true) {
        data = Functions.exibirVermelhos(data, this.data_secretaria_de_saude)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data, this.data_secretaria_de_saude)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      let visita = this.visita
      if (this.visita === null) {
        this.visita = ''
        visita = {
          visita: 'Todos',
        }
      }
      if (visita !== '') {
        data = this.handleVisita(data, visita)
      } else {
      }

      this.cadastros = data
      await this.loadMap()
    },

    loadMap() {
      if (this.cadastros) {
        this.cadastrosMapa = this.cadastros.filter((item) => {
          return (
            item.lat !== '0' &&
            item.lat !== null &&
            item.lng !== '0' &&
            item.lng !== null
          )
        })
        setTimeout(() => {
          const cod_ibge = this.$store.state.cod_ibge
          const state = this.$store.state.cidade.split('-')[1].trim()

          // pega as coordenadas do municipio
          const countyCoordinates = mapa.find((item) => {
            return item.co_ibge === cod_ibge
          })

          // pega o zoom para o estado
          const coordinatesState = coordinates.find((item) => {
            return item.uf === state
          })
          const mapObject = this.$refs.map.mapObject

          mapObject.invalidateSize(true)
          // Faz com que não de zoom quando "semZoom" é true
          if (this.semZoom === false) {
            mapObject.setView(
              latLng(countyCoordinates.local[0], countyCoordinates.local[1]),
              coordinatesState.zoom + 4
            )
          }
          // Caso "semZoom" seja true o sistema reseta para false para o zoom
          // ocorrer nos outros filtros
          this.semZoom = false
        }, 500)
      } else {
        setTimeout(() => {
          const mapObject = this.$refs.map.mapObject
          mapObject.invalidateSize(true)
          mapObject.setView(this.center, 5)
        }, 500)
      }
    },

    handleVisita(data, event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      const visitado = event.visita

      let filtrado = data.filter((item) => {
        if (visitado === 'Todos') {
          return item
        } else if (visitado === 'Realizada') {
          return item.desfecho === '1'
        } else if (visitado === 'Ausente') {
          return item.desfecho === '3'
        } else {
          return item
        }
      })
      // Faz com que não de zoom quando esse filtro é ativado
      this.semZoom = true
      return filtrado
    },
    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = false
      }
      // Faz com que não de zoom quando esse filtro é ativado
      this.semZoom = true
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = false
      }
      // Faz com que não de zoom quando esse filtro é ativado
      this.semZoom = true
    },
    resetColor() {
      this.setColor = false
      this.exibirCadastrosVerdes = false
      this.exibirCadastrosVermelhos = false
    },
    iconColor(dt_ultima_visita, desfecho, lat, lng) {
      if (dt_ultima_visita !== null || dt_ultima_visita !== undefined) {
        let diff = this.diffDates(dt_ultima_visita)

        if (diff > 30 || dt_ultima_visita == null || desfecho != 1) {
          return this.iconVermelho
        } else {
          return this.iconVerde
        }
      } else {
        return this.iconVerde
      }
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.tabsActive = 0
        this.loading = true
        this.visita = ''
        this.setColor = true
        this.profissional = ''
        this.equipe = event
        this.nomeEquipe = event.no_equipe
        this.cadastros = []
        this.nomeProfissional = ''
        this.secretaria_municipal_de_saude_total_na_equipe = 0
        this.secretaria_municipal_de_saude_na_equipe_atualizados = 0
        this.secretaria_municipal_de_saude_na_equipe_desatualizados = 0
        try {
          this.secretaria_municipal_de_saude_total_no_acs = 0
          this.secretaria_municipal_de_saude_no_acs_atualizados = 0
          this.secretaria_municipal_de_saude_no_acs_desatualizados = 0
          await this.buscarTodosPorEquipe()
          // dados da equipe
          const dadosDaEquipe = this.dadosDoResultado.find((item) => {
            return item.ibge_ine === this.equipe.nu_ine
          })
          this.secretaria_municipal_de_saude_total_na_equipe = parseInt(
            dadosDaEquipe.denominador
          )
          this.secretaria_municipal_de_saude_na_equipe_atualizados = parseInt(
            dadosDaEquipe.resultado
          )
          this.secretaria_municipal_de_saude_na_equipe_desatualizados =
            100 -
            parseInt(this.secretaria_municipal_de_saude_na_equipe_atualizados)

          this.loading = false
          this.loadMap()
        } catch (error) {
          console.log(error)
        }
      } else {
        this.tabsActive = 0
        this.visita = ''
        this.setColor = true
        this.profissional = ''
        this.nomeProfissional = ''
        this.equipe = ''
        this.nomeEquipe = ''
        this.cadastros = []
        this.cadastrosOriginais = []
        this.secretaria_municipal_de_saude_total_na_equipe = 0
        this.secretaria_municipal_de_saude_na_equipe_atualizados = 0
        this.secretaria_municipal_de_saude_na_equipe_desatualizados = 0
      }
    },
    // Busca os dados referentes a cidade ao abrir a página
    async buscarDadosIniciais() {
      try {
        this.loading = true
        let response = await this.$api.get(
          '/app/indicadores-aps/resultado/' + this.cod_ibge + '/20'
        )
        if (response) {
          this.dadosDoResultado = response.data
          // dados do município
          const dadosDoMunicipio = response.data.find((item) => {
            return item.ibge_ine === 'MUN'
          })
          this.secretaria_municipal_de_saude_total_no_municipio = parseInt(
            dadosDoMunicipio.denominador
          )
          this.secretaria_municipal_de_saude_no_municipio_atualizados =
            dadosDoMunicipio.resultado
          this.secretaria_municipal_de_saude_no_municipio_desatualizados =
            100 -
            parseInt(
              this.secretaria_municipal_de_saude_no_municipio_atualizados
            )
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    onChangeProfissional(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.tabsActive = 0
      this.visita = ''
      this.setColor = true
      this.page = 1
      if (event !== null) {
        this.profissional = event.nu_cpf
        this.nomeProfissional = event.no_profissional
        this.buscarDados()
      } else {
        this.cadastrosMapa = []
        this.cidadaos_visitados = []
        this.cadastrosOriginais = []
        this.cadastros = []
        setTimeout(() => {
          const mapObject = this.$refs.map.mapObject
          this.zoom = 5
          mapObject.invalidateSize(true)
          mapObject.setView(this.center, 5)
        }, 500)
      }
    },

    async buscarTodosPorEquipe() {
      try {
        this.loading = true
        const response = await this.$api.get(
          '/app/cidadaos-visitados/detalhado/equipe/' +
            this.cod_ibge +
            '/' +
            this.equipe.nu_ine
        )
        if (response) {
          this.cadastros = response.data
          this.cadastrosOriginais = response.data
          this.total_de_registros_da_tabela = response.data.length
          this.visibleTable = true
          this.filtros(
            this.exibirCadastrosVermelhos,
            this.exibirCadastrosVerdes
          )
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    // busca os dados de acordo com os valores do select
    async buscarDados() {
      try {
        this.secretaria_municipal_de_saude_total_no_acs = 0
        this.secretaria_municipal_de_saude_no_acs_atualizados = 0
        this.secretaria_municipal_de_saude_no_acs_desatualizados = 0

        this.loading = true
        const profissional = await this.$api.get(
          '/app/profissional/' + this.profissional + '/' + this.cod_ibge
        )
        if (profissional) {
          // dados do acs
          const dadosDoAcs = this.dadosDoResultado.find((item) => {
            return item.ibge_ine === profissional.data.nu_cpf
          })

          if (dadosDoAcs !== undefined) {
            this.secretaria_municipal_de_saude_total_no_acs = parseInt(
              dadosDoAcs.denominador
            )
            this.secretaria_municipal_de_saude_no_acs_atualizados = parseInt(
              dadosDoAcs.resultado
            )
            this.secretaria_municipal_de_saude_no_acs_desatualizados =
              100 -
              parseInt(this.secretaria_municipal_de_saude_no_acs_atualizados)
          }

          const cidadaos_visitados = await this.$api.get(
            '/app/cidadaos-visitados/' +
              profissional.data.co_ibge +
              '/' +
              profissional.data.nu_cpf
          )
          this.cidadaos_visitados = cidadaos_visitados
          if (cidadaos_visitados) {
            this.cadastros = cidadaos_visitados.data

            this.cadastrosOriginais = cidadaos_visitados.data
            this.total_de_registros_da_tabela = cidadaos_visitados.data.length
            this.visibleTable = true
            this.loading = false
            this.filtros(
              this.exibirCadastrosVermelhos,
              this.exibirCadastrosVerdes
            )
          }
        } else {
          this.loading = false
        }
      } catch (error) {
        console.log(error)
      }
    },

    // Formata os dados encontrados no mapa
    getRadius(desempenho) {
      const value = parseFloat(desempenho)
      const result = value / 30
      return result
    },

    /* Retorna a diferença de dias entre a data atual e a data passada como parâmetro */
    diffDates(date) {
      if (date !== null) {
        // let now = new Date(); // Data de hoje

        // data passada por parametro
        let dataSplit = date.split('-')
        let day = dataSplit[2]
        let month = dataSplit[1]
        let year = dataSplit[0]
        let date1 = new Date(year, month - 1, day)

        // data da última atualização
        let dataUltimaAtualizacao = this.data_secretaria_de_saude
        let dataSplitUltimaAtualizacao = dataUltimaAtualizacao.split('/')
        let date2 = new Date(
          dataSplitUltimaAtualizacao[2] +
            '/' +
            dataSplitUltimaAtualizacao[1] +
            '/' +
            dataSplitUltimaAtualizacao[0]
        )

        let timeDiff = Math.abs(date2.getTime() - date1.getTime())
        let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

        // console.log(date1);
        return parseInt(diffDays)
      } else {
        return '+157'
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.nomeProfissional,
        this.data_secretaria_de_saude
      )
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style scoped>
/* .idade {
  width: 70px;
} */
.filter-table {
  grid-template-columns: unset;
  justify-content: start;
}
.input-idade {
  gap: 10px;
}
.green {
  color: green;
}
.red {
  color: red;
}

@media (max-width: 768px) {
  button {
    margin-top: 0;
  }
}
@media (max-width: 922px) {
  .info-table {
    gap: 10px !important;
  }
}
@media (max-width: 992px) {
  .info-table {
    gap: 10px;
  }
  .input-idade {
    gap: 5px;
    flex-direction: column;
  }
  .filter-table {
    grid-template-columns: unset;
    justify-content: center;
  }
}
.select-visita {
  margin: 10px;
  min-width: 210px;
}
</style>
<style>
#cidadaos_visitados .mapa {
  z-index: 0;
}
#cidadaos_visitados .leaflet-container {
  z-index: 5;
}
#cidadaos_visitados .select-visita .vs__dropdown-menu {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 0px;
}
#cidadaos_visitados .select-visita .vs--searchable .vs__dropdown-toggle {
  padding: 5px;
}
#cidadaos_visitados .select-visita .v-select {
  width: 296px;
}
#cidadaos_visitados .select-visita .vs__dropdown-toggle {
  background-color: #fff;
}
</style>
